module.exports = __webpack_public_path__ + "static/media/shaff1139.df277e1e.jpg";